export const errorMessages = [
  { type: 'ADD', generic: 'Une erreur est survenue lors de la création.' },
  { type: 'EDIT', generic: "Une erreur est survenue lors de l'édition." },
  {
    type: 'DELETE',
    generic: 'Une erreur est survenue lors de la suppression.',
  },
  { type: 'REJECT', generic: 'Une erreur est survenue lors du rejet.' },
  { type: 'AFFECT', generic: "Une erreur est survenue lors de l'affectation." },
  {
    type: 'TAKE',
    generic: 'Une erreur est survenue en tenant de prendre la demande.',
  },
  {
    type: 'FREE',
    generic: 'Une erreur est survenue en tenant de libérer la demande.',
  },
  {
    errType: '500+',
    generic:
      "Le serveur a rencontré une erreur, veuillez réessayer. Si le problème persiste, contactez l'équipe de développement.",
  },
];

export function catchCRUDError(type, err) {
  const errors = (err.response &&
    (err.response.data ? err.response.data.errors : err.response.errors)) || [
    err,
  ];
  let message = null;
  if (errors[0].code && errors[0].code.startsWith('5')) {
    message = errorMessages.find((el) => el.errType === '500+');
  } else {
    message = errorMessages.find((el) => el.type === type);
  }
  return {
    message: message ? message.generic : 'Une erreur est survenue.',
    color: 'error',
    more: errors.map((error) => ({ error })),
    closeable: true,
  };
}
